import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Grow } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

interface SuccessOrErrorDialogProps {
  open: boolean;
  onClose: () => void;
  success: boolean; // Determines success or error state
  successTitle: string; // Title for success state
  successMessage: string; // Message for success state
  errorTitle: string; // Title for error state
  errorMessage: string; // Message for error state
  confirmButtonLabel?: string; // Optional confirm button label
  onConfirm?: () => void; // Optional confirm action
}

const SuccessOrErrorDialog: React.FC<SuccessOrErrorDialogProps> = ({
  open,
  onClose,
  success,
  successTitle,
  successMessage,
  errorTitle,
  errorMessage,
  confirmButtonLabel,
  onConfirm,
}) => {
  const title = success ? successTitle : errorTitle;
  const message = success ? successMessage : errorMessage;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      TransitionComponent={Grow}
      TransitionProps={{ timeout: 240 }}
      sx={{ '& .MuiDialog-paper': { borderRadius: 2, width: { xs: '95%', sm: 'auto' }, minHeight: 210 } }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1} sx={{ fontWeight: 700 }}>
          {success ? (
            <CheckCircleIcon sx={{ color: 'success.main', fontSize: 28 }} />
          ) : (
            <ErrorIcon sx={{ color: 'error.main', fontSize: 28 }} />
          )}
          {title}
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={{ minHeight: 88 }}>
        <Typography variant="body1">{message}</Typography>
      </DialogContent>
      <DialogActions>
        {confirmButtonLabel && onConfirm && (
          <Button
            onClick={onConfirm}
            color={success ? 'success' : 'error'}
            variant="contained"
            sx={{ textTransform: 'none', fontWeight: 600 }}
          >
            {confirmButtonLabel}
          </Button>
        )}
        <Button onClick={onClose} color="primary" variant="contained" sx={{ textTransform: 'none', fontWeight: 600 }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessOrErrorDialog;
